import { render, staticRenderFns } from "./DeqUser.vue?vue&type=template&id=772cf96b&scoped=true"
import script from "./DeqUser.vue?vue&type=script&lang=js"
export * from "./DeqUser.vue?vue&type=script&lang=js"
import style0 from "./DeqUser.vue?vue&type=style&index=0&id=772cf96b&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772cf96b",
  null
  
)

export default component.exports